import { render, staticRenderFns } from "./attr-category.vue?vue&type=template&id=a2389a1a&scoped=true&"
import script from "./attr-category.vue?vue&type=script&lang=js&"
export * from "./attr-category.vue?vue&type=script&lang=js&"
import style0 from "./attr-category.vue?vue&type=style&index=0&id=a2389a1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2389a1a",
  null
  
)

export default component.exports